import ScLink from 'components/Generic/SitecoreWrappers/ScLink';
import { HTMLAttributes, ReactNode, useMemo } from 'react';
import { LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

type AbrdnButtonProps = HTMLAttributes<HTMLElement> & {
  children?: ReactNode;
  buttonType?: string;
  isSuccess?: boolean;
  linkField?: LinkField;
  showExternalIcon?: boolean;
  replaceWithSlot?: boolean;
  className?: string;
  type?: HTMLButtonElement['type'];
  disabled?: boolean;
};
const AbrdnButton = ({
  children,
  buttonType,
  isSuccess = false,
  linkField,
  showExternalIcon = true,
  replaceWithSlot = true,
  className,
  onClick,
  type,
  ...rest
}: AbrdnButtonProps) => {
  const buttonTypeClassName = useMemo(() => {
    const buttonSuccess = isSuccess ? 'success' : '';
    switch (buttonType) {
      case 'primary':
        return `btn btn-primary button-label ${buttonSuccess} ${className}`;
      case 'secondary':
        return `btn btn-secondary button-label ${buttonSuccess} ${className}`;
      case 'textLink':
        return `btn btn-text-link text-link revert-underline ${buttonSuccess} ${className}`;
      default:
        return `btn btn-primary button-label ${className}`;
    }
  }, [buttonType, className, isSuccess]);
  if (linkField) {
    return (
      <ScLink
        field={linkField}
        replaceWithSlot={replaceWithSlot}
        showExternalIcon={showExternalIcon}
        className={buttonTypeClassName}
        {...rest}
      >
        {children}
      </ScLink>
    );
  } else {
    return (
      <button className={buttonTypeClassName} type={type} onClick={onClick} {...rest}>
        {children}
      </button>
    );
  }
};
export default AbrdnButton;
